module.exports = __webpack_public_path__ + "img/Selena-Gomez-Square.5a9729e9.webp";